<template>
  <transition name="modal">
    <div v-show="value" class="modal-overlay" @click.self="close">
      <div class="modal-backdrop" aria-hidden="true"></div>
      <div :class="['modal-wrapper', { 'modal-wrapper--half': half }]">
        <div :class="[modalPanelClass, { 'modal-panel--half': half }]" class="modal-panel">
          <div class="modal-header">
            <button
              type="button"
              class="modal-close"
              @click="close"
              aria-label="Close"
            >
              <i class="fa fa-times" aria-hidden="true"></i>
          
            </button>
          </div>
          <div class="modal-content">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AppModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    bgClass: {
      type: String,
      default: 'bg-white',
    },
    xs: { type: Boolean, default: false },
    sm: { type: Boolean, default: false },
    md: { type: Boolean, default: false },
    lg: { type: Boolean, default: false },
    xl: { type: Boolean, default: false },
    xl2: { type: Boolean, default: false },
    xl4: { type: Boolean, default: false },
    xl6: { type: Boolean, default: false },
    xl8: { type: Boolean, default: false },
    half: { type: Boolean, default: false },
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  computed: {
    modalPanelClass() {
      const base = 'w-full transform rounded-md z-65 text-left align-middle shadow-xl transition-all ' + this.bgClass;
      const sizes = {
        xs: 'max-w-xs',
        sm: 'max-w-sm',
        md: 'max-w-md',
        lg: 'max-w-lg',
        xl: 'max-w-xl',
        xl2: 'max-w-2xl',
        xl4: 'max-w-4xl',
        xl6: 'max-w-6xl',
        xl8: 'max-w-8xl',
      };
      for (const [key, cls] of Object.entries(sizes)) {
        if (this[key]) return base + ' ' + cls;
      }
      return base;
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
}
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 60;
}
.modal-wrapper {
  position: relative;
  z-index: 61;
  padding: 1rem;
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: stretch;
  justify-content: center;
}
.modal-panel {
  position: relative;
  margin: 0 auto;
  width: 100%;
  height: calc(100vh - 2rem);
  min-height: calc(100vh - 2rem);
  max-height: calc(100vh - 2rem);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.modal-wrapper--half {
  align-items: center;
  min-height: auto;
}
.modal-panel--half {
  height: auto;
  min-height: auto;
  max-height: 50vh;
}
.modal-panel--half .modal-content {
  flex: 1 1 auto;
}
.modal-header {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
  border-radius: 0.375rem 0.375rem 0 0;
}
.modal-close {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.75rem;
  background: #e5e7eb;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  line-height: 1;
  transition: background-color 0.15s, color 0.15s, border-color 0.15s;
}
.modal-close:hover {
  background: #dc2626;
  color: white;
  border-color: #dc2626;
}
.modal-close-text {
  font-size: 0.875rem;
}
.modal-content {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  padding: 1rem;
  position: relative;
}
.z-65 {
  z-index: 65;
}
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s ease;
}
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
